import DirectorsFilter from "./filters/DirectorsFilter";
import BaseFilter from "./filters/BaseFilter";
import MovieCountryFilter from "./filters/MovieCountryFilter";
import MovieFormatFilter from "./filters/MovieFormatFilter";
import MovieTypeFilter from "./filters/MovieTypeFilter";
import ProjectionPlacesFilter from "./filters/ProjectionPlacesFilter";
import ThematiqueFilter from "./filters/ThematiqueFilter";
import TitleFilter from "./filters/TitleFilter";
import './LeafletMap'
import './PartnersView'

document.addEventListener("DOMContentLoaded", function () {
    let option_fields = document.querySelectorAll(".grid-filters select, .grid-filters input");
    option_fields.forEach(option => {
        option.addEventListener("change", function () {
            let filters: BaseFilter[] = [];
            let baseClasses = [
                DirectorsFilter,
                MovieCountryFilter,
                MovieFormatFilter,
                MovieTypeFilter,
                ProjectionPlacesFilter,
                ThematiqueFilter,
                TitleFilter
            ];

            for (const baseClass of baseClasses) {
                if (baseClass.shouldBeInitialized()) {
                    filters.push(new baseClass());
                }
            }

            let gridItems = Array.from(document.getElementsByClassName("grid-item"));
            for (const gridItem of gridItems) {
                let shouldShow: boolean[] = [];
                for (const filter of filters) {
                    shouldShow.push(filter.shouldShow(<HTMLElement>gridItem));
                }

                if (shouldShow.includes(false)) {
                    (gridItem as HTMLElement).style.display = "none";
                } else {
                    (gridItem as HTMLElement).style.display = "block";
                }
            }

            // For the calendar view, checking if any dates are empty, and hiding them (or the inverse)

            let calendar_view = document.getElementsByClassName("calendar-movie-grid");
            if (calendar_view.length === 1) {
                let sections = Array.from(calendar_view[0].children as HTMLCollectionOf<HTMLElement>);
                for (const section of sections) {
                    let items = section.querySelectorAll(".items > div");
                    let displays = Array.from(items).map((x) => (x as HTMLElement).style.display);

                    if (displays.includes("block")) {
                        (section as HTMLElement).style.display = "grid";
                    } else {
                        (section as HTMLElement).style.display = "none";
                    }
                }
            }
        })
    })
});
